import * as React from "react";
import { cn } from "@/v2/lib/utils";
import type { LucideIcon } from "lucide-react";

export interface ChipProps {
  /** The color for text and border. */
  color: string;
  children: React.ReactNode;
  /** Optional leading icon (lucide-react icon component). */
  icon?: LucideIcon;
  /** Extra Tailwind / CSS classes. */
  className?: string;
  /** Size variant: sm → 10–11px text, md → 12px text (default). */
  size?: "sm" | "md";
}

const sizeClasses: Record<NonNullable<ChipProps["size"]>, string> = {
  sm: "text-[11px] px-3.5 py-0.5",
  md: "text-[12px] px-4.5 py-1",
};

/**
 * A non-interactive status chip / badge / label.
 */
export function Chip({
  color,
  children,
  icon: Icon,
  className,
  size = "md",
}: ChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wider whitespace-nowrap flex-shrink-0",
        sizeClasses[size],
        className,
      )}
      style={{
        color,
        border: `1px solid ${color}`,
      }}
    >
      {Icon && <Icon size={size === "sm" ? 12 : 13} style={{ color }} />}
      {children}
    </span>
  );
}
